/**
 * Spacing
 * Figma: https://www.figma.com/file/36q2en2Fb6AAepdm1I6NGn/Design-system?node-id=81%3A286
 */
import { pxToRem } from 'utils/convert';

export type SpacingValues = {
  /** @description 1px | 0.0625rem  */
  single: string;
  /** @description 2px | 0.125rem  */
  eighth: string;
  /** @description 4px | 0.25rem  */
  quarter: string;
  /** @description 6px | 0.375rem  */
  threeEights: string;
  /** @description 8px | 0.5rem  */
  half: string;
  /** @description 10px | 0.625rem  */
  fiveEights: string;
  /** @description 12px | 0.75rem  */
  threeQuarter: string;
  /** @description 16px | 1rem  */
  base: string;
  /** @description 20px | 1.25rem  */
  plusQuarter: string;
  /** @description 24px | 1.5rem  */
  plusHalf: string;
  /** @description 28px | 1.75rem  */
  plusThreeQuarter: string;
  /** @description 32px | 2rem  */
  double: string;
  /** @description 36px | 2.25rem  */
  doubleQuarter: string;
  /** @description 40px | 2.5rem  */
  doubleHalf: string;
  /** @description 48px | 3rem  */
  x3: string;
  /** @description 64px | 4rem  */
  x4: string;
  /** @description 80px | 5rem  */
  x5: string;
  /** @description 96px | 6rem  */
  x6: string;
  /** @description 112px | 7rem  */
  x7: string;
  /** @description 128px | 8rem  */
  x8: string;
  /** @description 160px | 10rem  */
  x10: string;
  /** @description 192px | 12rem  */
  x12: string;
  /** @description 256px | 16rem  */
  x16: string;
  /** @description 384px | 24rem  */
  x24: string;
  /** @description 512px | 32rem  */
  x32: string;
  /** @description 640px | 40rem  */
  x40: string;
  /** @description 768px | 48rem  */
  x48: string;
  layoutHorizontal: string;
  layoutVertical: string;
  /** @description 1216px | 86rem */
  normalPageMaxWidth: string;
};

export const scaleBase = (proportion: number, base = 16): number => base * proportion;

export const single = pxToRem(scaleBase(1 / 16)); // 1px | 0.0625rem
export const eighth = pxToRem(scaleBase(1 / 8)); // 2px | 0.125rem
export const quarter = pxToRem(scaleBase(0.25)); // 4px | 0.25rem
export const threeEights = pxToRem(scaleBase(0.375)); // 6px | 0.375rem
export const half = pxToRem(scaleBase(0.5)); // 8px | 0.5rem
export const fiveEights = pxToRem(scaleBase(0.625)); // 10px | 0.625rem
export const threeQuarter = pxToRem(scaleBase(0.75)); // 12px | 0.75rem
export const base = pxToRem(scaleBase(1)); // 16px | 1rem
export const plusQuarter = pxToRem(scaleBase(1.25)); // 20px | 1.25rem
export const plusHalf = pxToRem(scaleBase(1.5)); // 24px | 1.5rem
export const plusThreeQuarter = pxToRem(scaleBase(1.75)); // 28px | 1.750rem
export const double = pxToRem(scaleBase(2)); // 32px | 2rem
export const doubleQuarter = pxToRem(scaleBase(2.25)); // 36px | 2.25rem
export const doubleHalf = pxToRem(scaleBase(2.5)); // 40px | 2.25rem
export const x3 = pxToRem(scaleBase(3)); // 48px | 3rem
export const x4 = pxToRem(scaleBase(4)); // 64px | 4rem
export const x5 = pxToRem(scaleBase(5)); // 80px | 5rem
export const x6 = pxToRem(scaleBase(6)); // 96px | 6rem
export const x7 = pxToRem(scaleBase(7)); // 112px | 7rem
export const x8 = pxToRem(scaleBase(8)); // 128px | 8rem
export const x10 = pxToRem(scaleBase(10)); // 160px | 10rem
export const x12 = pxToRem(scaleBase(12)); // 192px | 12rem
export const x16 = pxToRem(scaleBase(16)); // 256px | 16rem
export const x24 = pxToRem(scaleBase(24)); // 384px | 24rem
export const x32 = pxToRem(scaleBase(32)); // 512px | 32rem
export const x40 = pxToRem(scaleBase(40)); // 640px | 40rem
export const x48 = pxToRem(scaleBase(48)); // 768px | 48rem

// This padding is applied by DefaultLayout, in case they need to be overridden
export const layoutLRPadding = pxToRem(32);
export const layoutTopPadding = pxToRem(20);

// https://zeroheight.com/3fe730a39/v/latest/p/022572-page/i/75685743
export const normalPageMaxWidth = pxToRem(1216);
export const normalPageMaxWidthWithMargin = pxToRem(1280);
export enum PageWidthStyle {
  fullWidth = 'fullWidth',
  normal = 'normal',
}
